import React, { Component } from 'react';
import styles from './Search.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import noUser from '../../../assets/no_user.jpg';
import { Link } from 'react-router-dom';

class Search extends Component {

    state = {
        users: [],
        showResult: false
    }

    searchRef = React.createRef();
    componentDidMount() {
        document.addEventListener('click', this.checkClickOutside);
    }

    checkClickOutside = (event) => {
        if(!this.searchRef.current.contains(event.target)) this.setState({showResult: false});
    }

    componentWillUnmount() {
         document.removeEventListener('click',  this.checkClickOutside);
    }

    onSearchTextChange = (event) => {
        const text = event.target.value.toLowerCase().trim();
        const users = [];

        if(text === '') {
            this.setState({users: users});
            return;
        }
        Object.keys(this.props.users).map(userId => {
            if(this.props.users[userId].name.toLowerCase().indexOf(text) !== -1) 
            users.push({[userId]: this.props.users[userId]})
        });

        users.sort((el1, el2)=> {
            return el1[Object.keys(el1)[0]].name.indexOf(text) < 
                   el2[Object.keys(el2)[0]].name.indexOf(text) ? -1 : 1
        })
        this.setState({users: users, showResult: true});
    }

    onFocusHandler = (event) => {
        if(event.target.value.trim() !== '') this.setState({showResult: true});
    }
    render() {
        return(
            <div className={styles.search} ref={this.searchRef}>
                <FontAwesomeIcon icon={faSearch} color="#9d9d9d"/>
                <input type="text" placeholder="Search" onChange={this.onSearchTextChange} onFocus={this.onFocusHandler}/>
                {this.state.showResult ?

                <div className={styles.searchResult}>
                    {this.state.users.length === 0 ?
                        <div className={styles.noResult}>No Results Found</div>:null
                    }
                    {this.state.users.map(obj=>{
                        const userId = Object.keys(obj)[0];
                        const user = obj[userId];
                        if(userId === this.props.userId) return;
                        return(
                            <div className={styles.user} key={userId}>
                                <div className={styles.dp}>
                                 <Link to={'/account/' + userId} >
                                  <img src={user.profilePic ? user.profilePic : noUser} 
                                  width="35" height="35" alt={user.name + '\'s profile pic'} /> 
                                  </Link>
                                </div>
                                <div className={styles.details}>
                                <Link to={'/account/' + userId} >
                                 <div className={styles.name}>
                                    <h2>{user.name}</h2> 
                                    {user.isVerified ?
                                    <span style={{marginLeft:'5px'}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="16px" height="16px">
                                    <polygon fill="#42a5f5" points="29.62,3 33.053,8.308 39.367,8.624 39.686,14.937 44.997,
                                    18.367 42.116,23.995 45,29.62 39.692,33.053 39.376,39.367 33.063,39.686 29.633,44.997 24.005,
                                    42.116 18.38,45 14.947,39.692 8.633,39.376 8.314,33.063 3.003,29.633 5.884,24.005 3,18.38 8.308,
                                    14.947 8.624,8.633 14.937,8.314 18.367,3.003 23.995,5.884"/>
                                    <polygon fill="#fff" points="21.396,31.255 14.899,24.76 17.021,22.639 21.428,27.046 30.996,
                                    17.772 33.084,19.926"/>
                                    </svg>
                                    </span>
                                    : null
                                    }
                                    
                                </div>
                                </Link>
                                </div>
                            </div>
                        )
                    })
                    }
                </div>
                 :null}
            </div>
        )
    }
}

export default Search;